import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=02f3cdd7&scoped=true"
import script from "./BasicForm.vue?vue&type=script&lang=js"
export * from "./BasicForm.vue?vue&type=script&lang=js"
import style0 from "./BasicForm.vue?vue&type=style&index=0&id=02f3cdd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f3cdd7",
  null
  
)

export default component.exports